import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: /join/* children (verify) render through here.
// The waitlist page itself lives at ./join/index.tsx ("/join/").
export const Route = createFileRoute("/join")({
  component: () => <Outlet />,
});
